import { Box } from "@mui/material";
import PropTypes from "prop-types";
import React, { memo, ReactNode } from "react";

interface TabPanelProps {
    children?: ReactNode;
    value: any;
    index: number;
    [key: string]: any;
}

export const TabPanel: React.FC<TabPanelProps> = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}> {children} </Box>}
        </div>
    );
};

export const a11yProps = (index: number) => {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
};
